<template>
  <div class="AccessoryOrderExport">
    <b-container>
      <b-button class="back" variant="primary" @click="back">Back</b-button>
      <br><br>
      <b-row align-v="center">
        <b-col cols="6">
          <h1>Purchase Order</h1>
        </b-col>
        <b-col class="text-center" cols="6">
          <img src="../assets/StonemartLogo.png">
        </b-col>
        <b-col cols="6">
          <strong>SUPPLIER:</strong> {{this.exportAccessoryOrder.supplier_name}}
        </b-col>
        <b-col cols="6">
          <strong>DATE:</strong> {{this.exportAccessoryOrder.ordered_date}}
        </b-col>
        <b-col cols="6">
          <strong>STORE LOCATION:</strong> {{this.exportAccessoryOrder.store_location}}
        </b-col>
        <b-col cols="6">
          <strong>SALES PERSON:</strong> {{this.exportAccessoryOrder.sales_name}}
        </b-col>
        <b-col cols="12">
          <br>
          <strong>ACCESSORIES:</strong>
        </b-col>
        <b-col cols="12">
          <b-table
            bordered
            :fields="fields"
            :items="this.exportAccessoryOrder.items"
            small
          >
            <template #cell(name)="row">
              {{row.item.item_name}}
            </template>

            <template #cell(description)="row">
              <p style="width: 440px">
                {{row.item.item_description}}
                <span v-if="row.item.item_type == 'Door'">
                  {{+ ', ' + row.item.door_size
                  + ', ' + row.item.door_frame_color
                  + ', ' + row.item.door_perspex_color}}
                </span>
              </p>
            </template>

            <template #cell(quantity)="row">
              <p>
                {{row.item.item_quantity}}
              </p>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12">
          <strong>Is this a re-order:</strong> {{this.exportAccessoryOrder.is_reordered?"YES":"NO"}}
        </b-col>
        <b-col v-if="this.exportAccessoryOrder.is_reordered" cols="12">
          <strong>REASON:</strong> {{this.exportAccessoryOrder.reordered_reason}}
        </b-col>
        <b-col cols="12">
          <strong>Pick Up?:</strong> {{this.exportAccessoryOrder.is_pickup?"YES":"NO"}}
        </b-col>
        <b-col v-if="!this.exportAccessoryOrder.is_pickup" cols="12">
          <strong>Post to:</strong> {{this.exportAccessoryOrder.post_to}}
        </b-col>
        <b-col cols="12">
          <br>
          <strong>Sales Person Signature:</strong>
        </b-col>
        <b-col class="text-center" cols="12">
          <br><br><br><br><br>
          Tel: 03-93590898 Fax: 03-93599196 Email: info@johnstonemart.com website: www.johnstonemart.com.au
        </b-col>
        <b-col class="text-center" cols="12">
          310 Mahoneys Road, Thomastown VIC 3074
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'AccessoryOrderExport',
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name'},
        { key: 'description', label: 'Description'},
        { key: 'quantity', label: 'Quantity'},
      ],
    }
  },
  props: {
    user: Object,
    exportAccessoryOrder: Object,
  },
  methods: {
    back() {
      this.$emit('backToAccessoryOrders');
    }
  }
}
</script>

<style scoped>
@media print {
  .back {
    visibility: hidden;
  }
}

@page {
  size: auto;   /* auto is the initial value */
  margin: 0;  /* this affects the margin in the printer settings */
}
</style>